export const vehiclePlotTags={
    1: "Vehicle tasks",
    2: "Vehicle completed tasks",
   
};

export const propertyPlotTags={
    1: "Propery tasks",
    2: "Property completed tasks",
};